function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 12H31C31.5523 12 32 12.4477 32 13V22C32 22.5523 31.5523 23 31 23H28V25H31C32.6569 25 34 23.6569 34 22V13C34 11.3431 32.6569 10 31 10H22C20.3431 10 19 11.3431 19 13V16H21V13C21 12.4477 21.4477 12 22 12ZM16 19V21H13C12.4477 21 12 21.4477 12 22V31C12 31.5523 12.4477 32 13 32H22C22.5523 32 23 31.5523 23 31V28H25V31C25 32.6569 23.6569 34 22 34H13C11.3431 34 10 32.6569 10 31V22C10 20.3431 11.3431 19 13 19H16Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25 19H19V25H25V19Z",
  fill: "currentColor"
});

var SvgMerge = function SvgMerge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMerge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/merge.9ad10692.svg";
export { ForwardRef as ReactComponent };